import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { handleResponseThrowError } from '@/_utils/services';
import { HEADER_TOTAL_COUNT } from '@/_config/lib/axios/interceptors';
import { GET_BANKS } from '../../api/constants';
import type { GetBanksResponse } from '../../api/types';
import type { Bank } from '../../types';
import { apiClient } from '@/_config/lib/axios/api-client';

const getBanks = (): Promise<GetBanksResponse> => {
  return apiClient
    .get<Bank[]>('/utils/list-banks')
    .then(response => ({
      data: response.data,
      totalCount: parseInt(response.headers[HEADER_TOTAL_COUNT] || '', 10),
    }))
    .catch(handleResponseThrowError());
};

export const useGetBanks = (
  options: Omit<
    UseQueryOptions<GetBanksResponse, unknown, GetBanksResponse, string[]>,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_BANKS],
    queryFn: () => getBanks(),
    ...options,
  });
};
